import {
	SET_CURRENCIES,
	SET_CURRENCY,
	CLEAR_CURRENCIES,
	CLEAR_CURRENCY,
	ADD_CURRENCY,
	UPDATE_CURRENCY,
	REMOVE_CURRENCY,
} from './actionTypes';

export const currency = (state = {}, action) => {
	switch (action.type) {
		case SET_CURRENCY:
			return action.payload;
		case UPDATE_CURRENCY:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_CURRENCY:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_CURRENCIES:
			return action.payload;
		case ADD_CURRENCY:
			return [...state, action.payload];
		case UPDATE_CURRENCY:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_CURRENCY:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_CURRENCIES:
			return [];
		default:
			return state;
	}
};
